export default () => localStorage.getItem('currentBrand');
